/**
 * me 命名空间字典（i18n 分区）
 *
 * 从原 translations.ts 主字典按 key 首个点分段拆出；本文件内 key 不带命名空间前缀，
 * 调用点写 t('me:key')。字段内容与拆分前逐字节一致。
 */

import type { TranslationDict } from '../types'

export const meZh: TranslationDict = {

  // ======================== 我的页面 / MePage ========================
  'title': '我的',
  'aiCountCard': '创建的 AI',
  'friendCountCard': '好友',
  'groupCountCard': '加入的群聊',
  'storageUsedCard': '已用存储',
  'admin': '管理员',
  'adminBadge': '管理员',
  'aiLabel': 'AI',
  'daysSuffix': '天',
  'editProfile': '编辑资料',
  'avatarTypeError': '仅支持 JPEG/PNG/GIF/WebP',
  'editProfileModalTitle': '编辑资料',
  'changeAvatar': '更换头像',
  'uploadingAvatar': '上传中...',
  'username': '用户名',
  'usernameField': '用户名',
  'password': '密码',
  'passwordHint': '留空不修改',
  'passwordField': '新密码（留空不修改）',
  'passwordMinHint': '至少 6 位',
  'bio': '简介',
  'bioField': '简介',
  'bioPlaceholder': '写一句话介绍自己...',
  'statusTextField': '个性状态',
  'statusTextPlaceholder': '输入状态，如"忙碌中"',
  'statusColorLabel': '状态颜色',
  'statusColorCustom': '自定义颜色',
  'save': '保存',
  'saveButton': '保存',
  'savingProfile': '保存中...',
  'aiQuota': 'AI 创建',
  'aiQuotaCard': 'AI 创建',
  'apiCredit': '通用额度',
  'apiCreditCard': '通用额度',
  'bundleCredit': '包断额度',
  'bundleCreditCard': '包断额度',
  'fileQuota': '文件配额',
  'fileQuotaCard': '文件配额',
  'myAi': '我的 AI',
  'myAiSection': '我的 AI',
  'viewAll': '查看全部',
  'noAi': '还没有 AI',
  'noAiLink': '还没有 AI，',
  'goCreate': '去创建 →',
  'stateActive': '在线',
  'stateDnd': '勿扰',
  'stateOffline': '离线',
  'stateBlocked': '已屏蔽',
  'apiUsage': 'API 用量',
  'apiUsage30d': 'API 用量（近30天）',
  'totalTokens': '总 Token',
  'calls': '调用次数',
  'cacheHitRate': '缓存命中率',
  'thinkingTokens': '思考 Token',
  'viewDetails': '查看详细',
  'storage': '存储空间',
  'storageSection': '存储空间',
  'noStorage': '暂无存储数据',
  'noStorageData': '暂无存储数据',
  'fileCount': '文件数',
  'fileCountSuffix': '个文件',
  'viewFiles': '查看文件',
  'used': '已用',
  'quota': '配额',
  'storageWarning': '存储空间即将用尽，请清理文件或兑换更多配额',
  'redeemCode': '兑换码',
  'redeemSection': '兑换码',
  'redeemPlaceholder': '输入兑换码',
  'redeem': '兑换',
  'redeemButton': '兑换',
  'settings': '设置',
  'apiConfig': 'API 配置',
  'apiConfigLink': 'API 配置',
  'apiConfigDesc': 'Base URL / API Key / 测试连接',
  'appearance': '外观与通知',
  'appearanceLink': '外观与通知',
  'appearanceDesc': '主题 / 通知开关 / 聊天样式',
  'language': '语言与时区',
  'languageLink': '语言与时区',
  'languageDesc': '中文/English · 时区设置',
  'management': '管理面板',
  'managementSection': '管理面板',
  'managementDesc': '用户 / AI / 群聊 / 兑换码 / 联邦 / 用量分析',
  'federation': '联邦管理',
  'logout': '退出登录',
  'daysOnline': '上线天数',
  'friends': '好友',
}

export const meEn: TranslationDict = {
  'title': 'Me',
  'aiCountCard': 'AI Created',
  'friendCountCard': 'Friends',
  'groupCountCard': 'Groups Joined',
  'storageUsedCard': 'Storage Used',
  'admin': 'Admin',
  'adminBadge': 'Admin',
  'aiLabel': 'AI',
  'daysSuffix': ' days',
  'editProfile': 'Edit Profile',
  'avatarTypeError': 'Only JPEG/PNG/GIF/WebP are supported',
  'editProfileModalTitle': 'Edit Profile',
  'changeAvatar': 'Change Avatar',
  'uploadingAvatar': 'Uploading...',
  'username': 'Username',
  'usernameField': 'Username',
  'password': 'Password',
  'passwordHint': 'Leave blank to keep current',
  'passwordField': 'New Password (leave blank to keep current)',
  'passwordMinHint': 'At least 6 characters',
  'bio': 'Bio',
  'bioField': 'Bio',
  'bioPlaceholder': 'Write a short bio...',
  'statusTextField': 'Status',
  'statusTextPlaceholder': 'Enter a status, e.g. "Busy"',
  'statusColorLabel': 'Status Color',
  'statusColorCustom': 'Custom color',
  'save': 'Save',
  'saveButton': 'Save',
  'savingProfile': 'Saving...',
  'aiQuota': 'AI Slots',
  'aiQuotaCard': 'AI Slots',
  'apiCredit': 'API Credit',
  'apiCreditCard': 'API Credit',
  'bundleCredit': 'Bundle Credit',
  'bundleCreditCard': 'Bundle Credit',
  'fileQuota': 'File Quota',
  'fileQuotaCard': 'File Quota',
  'myAi': 'My AI',
  'myAiSection': 'My AI',
  'viewAll': 'View All',
  'noAi': 'No AI yet',
  'noAiLink': 'No AI yet, ',
  'goCreate': 'Create one',
  'stateActive': 'Online',
  'stateDnd': 'Do Not Disturb',
  'stateOffline': 'Offline',
  'stateBlocked': 'Blocked',
  'apiUsage': 'API Usage',
  'apiUsage30d': 'API Usage (30 days)',
  'totalTokens': 'Total Tokens',
  'calls': 'Calls',
  'cacheHitRate': 'Cache Hits',
  'thinkingTokens': 'Thinking Tokens',
  'viewDetails': 'View Details',
  'storage': 'Storage',
  'storageSection': 'Storage',
  'noStorage': 'No storage data',
  'noStorageData': 'No storage data',
  'fileCount': 'Files',
  'fileCountSuffix': ' file(s)',
  'viewFiles': 'View files',
  'used': 'Used',
  'quota': 'Quota',
  'storageWarning': 'Storage almost full. Please clean up files or redeem more quota.',
  'redeemCode': 'Redeem Code',
  'redeemSection': 'Redeem Code',
  'redeemPlaceholder': 'Enter code',
  'redeem': 'Redeem',
  'redeemButton': 'Redeem',
  'settings': 'Settings',
  'apiConfig': 'API Config',
  'apiConfigLink': 'API Config',
  'apiConfigDesc': 'Base URL / API Key / Test Connection',
  'appearance': 'Appearance & Notifications',
  'appearanceLink': 'Appearance & Notifications',
  'appearanceDesc': 'Theme / Notifications / Chat Style',
  'language': 'Language & Timezone',
  'languageLink': 'Language & Timezone',
  'languageDesc': 'English / 中文 · Timezone',
  'management': 'Admin Panel',
  'managementSection': 'Admin Panel',
  'managementDesc': 'Users / AI / Groups / Redeem Codes / Federation / Usage',
  'federation': 'Federation',
  'logout': 'Logout',
  'daysOnline': 'Days Online',
  'friends': 'Friends',
}

export const meJa: TranslationDict = {
  'title': 'マイ',
  'aiCountCard': '作成した AI',
  'friendCountCard': 'フレンド',
  'groupCountCard': '参加グループ',
  'storageUsedCard': 'ストレージ使用量',
  'admin': '管理者',
  'adminBadge': '管理者',
  'aiLabel': 'AI',
  'daysSuffix': '日',
  'editProfile': 'プロフィール編集',
  'avatarTypeError': 'JPEG/PNG/GIF/WebP のみ対応しています',
  'editProfileModalTitle': 'プロフィール編集',
  'changeAvatar': 'アバター変更',
  'uploadingAvatar': 'アップロード中...',
  'username': 'ユーザー名',
  'usernameField': 'ユーザー名',
  'password': 'パスワード',
  'passwordHint': '変更しない場合は空欄',
  'passwordField': '新しいパスワード（変更しない場合は空欄）',
  'passwordMinHint': '6文字以上',
  'bio': '自己紹介',
  'bioField': '自己紹介',
  'bioPlaceholder': '一言自己紹介をどうぞ...',
  'statusTextField': 'ステータス',
  'statusTextPlaceholder': '例: 「取り込み中」',
  'statusColorLabel': 'ステータスカラー',
  'statusColorCustom': 'カスタム色',
  'save': '保存',
  'saveButton': '保存',
  'savingProfile': '保存中...',
  'aiQuota': 'AI作成枠',
  'aiQuotaCard': 'AI作成枠',
  'apiCredit': 'APIクレジット',
  'apiCreditCard': 'APIクレジット',
  'bundleCredit': 'パッケージクレジット',
  'bundleCreditCard': 'パッケージクレジット',
  'fileQuota': 'ファイル容量',
  'fileQuotaCard': 'ファイル容量',
  'myAi': 'マイ AI',
  'myAiSection': 'マイ AI',
  'viewAll': 'すべて見る',
  'noAi': 'まだ AI がありません',
  'noAiLink': 'まだ AI がありません。',
  'goCreate': '作成する →',
  'stateActive': 'オンライン',
  'stateDnd': 'おやすみ',
  'stateOffline': 'オフライン',
  'stateBlocked': 'ブロック中',
  'apiUsage': 'API 使用量',
  'apiUsage30d': 'API 使用量（直近30日）',
  'totalTokens': '総トークン',
  'calls': '呼び出し回数',
  'cacheHitRate': 'キャッシュヒット率',
  'thinkingTokens': '思考トークン',
  'viewDetails': '詳細を見る',
  'storage': 'ストレージ',
  'storageSection': 'ストレージ',
  'noStorage': 'データなし',
  'noStorageData': 'データなし',
  'fileCount': 'ファイル数',
  'fileCountSuffix': ' ファイル',
  'viewFiles': 'ファイルを見る',
  'used': '使用中',
  'quota': '容量',
  'storageWarning': 'ストレージがまもなく一杯です。ファイルを整理するか、容量を追加してください',
  'redeemCode': '交換コード',
  'redeemSection': '交換コード',
  'redeemPlaceholder': 'コードを入力',
  'redeem': '交換',
  'redeemButton': '交換',
  'settings': '設定',
  'apiConfig': 'API 設定',
  'apiConfigLink': 'API 設定',
  'apiConfigDesc': 'Base URL / API Key / 接続テスト',
  'appearance': '外観と通知',
  'appearanceLink': '外観と通知',
  'appearanceDesc': 'テーマ / 通知 / チャットスタイル',
  'language': '言語とタイムゾーン',
  'languageLink': '言語とタイムゾーン',
  'languageDesc': '日本語 / 中文 · タイムゾーン',
  'management': '管理パネル',
  'managementSection': '管理パネル',
  'managementDesc': 'ユーザー / AI / グループ / 交換コード / 連合 / 使用量',
  'federation': '連合管理',
  'logout': 'ログアウト',
  'daysOnline': 'オンライン日数',
  'friends': 'フレンド',
}
